import { IPreloadedState } from 'shared/types/redux';

export const selectPageType = (state: IPreloadedState) => state.page.type;
